// extracted by mini-css-extract-plugin
export var body = "Content-module--body--726c2";
export var content = "Content-module--content--80d58";
export var title = "Content-module--title--09504";